/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AppRole = {
    AdvancedConfigurationAdmin: 'AdvancedConfigurationAdmin',
    AppCustomizationAdmin: 'AppCustomizationAdmin',
    ContentManagementAdmin: 'ContentManagementAdmin',
    CostReportingAdmin: 'CostReportingAdmin',
    GlossaryAdmin: 'GlossaryAdmin',
    LegalInformationAdmin: 'LegalInformationAdmin',
    UserBudgetMonitoringAdmin: 'UserBudgetMonitoringAdmin',
    ChatbotFeature: 'ChatbotFeature',
    SummarizationFeature: 'SummarizationFeature',
    TranscriptionFeature: 'TranscriptionFeature',
    TranslationFeature: 'TranslationFeature',
    ImageGenerationFeature: 'ImageGenerationFeature'
} as const;
export type AppRole = typeof AppRole[keyof typeof AppRole];


export function instanceOfAppRole(value: any): boolean {
    for (const key in AppRole) {
        if (Object.prototype.hasOwnProperty.call(AppRole, key)) {
            if (AppRole[key as keyof typeof AppRole] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AppRoleFromJSON(json: any): AppRole {
    return AppRoleFromJSONTyped(json, false);
}

export function AppRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppRole {
    return json as AppRole;
}

export function AppRoleToJSON(value?: AppRole | null): any {
    return value as any;
}

export function AppRoleToJSONTyped(value: any, ignoreDiscriminator: boolean): AppRole {
    return value as AppRole;
}

